import React, { useEffect } from "react"
import { useSetRecoilState } from "recoil"
import { blockVisibilityState } from "./atoms"
import { useInView } from "react-intersection-observer"
import { Box } from "@chakra-ui/react"

interface Props {
  id: string
  children: React.ReactNode
}

const FloatingActionSensor: React.FC<Props> = ({ id, children }) => {
  const setBlockVisibility = useSetRecoilState(blockVisibilityState(id))

  const [ref, inView] = useInView({
    threshold: 0.2,
  })

  useEffect(() => {
    if (inView) {
      setBlockVisibility(true)
    } else {
      setBlockVisibility(false)
    }
  }, [inView, setBlockVisibility])

  return <Box ref={ref}>{children}</Box>
}

export default FloatingActionSensor
